import { Box, Tooltip, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";

const RenderBox = ({ row, field }) => {
	return (
		<Box
			width={"100%"}
			height="100%"
			display="flex"
			alignItems="center"
			justifyContent="center"
			sx={{ background: row?.STORE === "Total" ? grey[200] : "inherit" }}>
			<Tooltip title={row["headerName"]}>
				<Typography noWrap variant={row?.STORE === "Total" ? "h6" : "body2"}>
					{row[field]}
				</Typography>
			</Tooltip>
		</Box>
	);
};
const columns = [
	// { field: "id", headerName: "ID", width: 90 },
	{
		field: "STORE",
		headerName: "Store",
		flex: 1,
		headerAlign: "center",
		align: "center",
		renderCell: ({ row, field }) => {
			return <RenderBox row={row} field={field} />;
		},
	},
	{
		field: "store_grade",
		headerName: "Store Grade",
		flex: 1,
		headerAlign: "center",
		align: "center",
		renderCell: ({ row, field }) => {
			return <RenderBox row={row} field={field} />;
		},
	},
	{
		field: "total_sale_7_days",
		tool_tip: "This is last 7 Days Sale",
		headerName: "7 D",
		type: "number",
		flex: 1,
		headerAlign: "center",
		align: "center",

		renderCell: ({ row, field }) => {
			return <RenderBox row={row} field={field} />;
		},
	},
	{
		field: "total_sale_15_days",
		headerName: "15 D",
		tool_tip: "This is last 15 Days Sale",
		type: "number",
		flex: 1,
		headerAlign: "center",
		align: "center",
		renderCell: ({ row, field }) => {
			return <RenderBox row={row} field={field} />;
		},
	},
	{
		field: "TOTAL_SOH",
		headerName: "SOH",
		type: "number",
		flex: 1,
		headerAlign: "center",
		align: "center",
		renderCell: ({ row, field }) => {
			return <RenderBox row={row} field={field} />;
		},
	},
	{
		field: "GIT",
		headerName: "GIT",
		type: "number",
		flex: 1,
		headerAlign: "center",
		align: "center",
		renderCell: ({ row, field }) => {
			return <RenderBox row={row} field={field} />;
		},
	},
	{
		field: "SO_QTY",
		headerName: "SO",
		type: "number",
		flex: 1,
		headerAlign: "center",
		align: "center",
		renderCell: ({ row, field }) => {
			return <RenderBox row={row} field={field} />;
		},
	},
	{
		field: "FINAL_ALLOCATION",
		headerName: "Final Allocation",
		type: "number",
		flex: 1,
		headerAlign: "center",
		align: "center",
		renderCell: ({ row, field }) => {
			return <RenderBox row={row} field={field} />;
		},
	},
];

const ResultTable = ({ tableRows }) => {
	return (
		<Box width="100%">
			{/* <Typography variant="body2">
				<span style={{ color: "red" }}>*</span> Total Store SOH is included with GIT
			</Typography> */}
			{/* <Box display="flex" justifyContent="flex-end" width="100%">
                            <Button variant="contained" startIcon={<DownloadRounded />} onClick={onDownloadClick}>
                                Download
                            </Button>
                        </Box> */}
			<DataGrid
				rows={tableRows}
				getRowId={(row) => row?.SITECODE}
				columns={columns}
				sx={{
					height: "60vh",
					width: "100%",
					border: "none",
					"& .MuiDataGrid-row": {
						// borderBottom: "1px solid lightgray",
						cursor: "pointer",
						border: "none",
					},
					"& .MuiDataGrid-cell": {
						// borderBottom: "1px solid lightgray",
						padding: 0,
					},
					"& .MuiDataGrid-columnHeader": {
						cursor: "pointer",
						background: grey[300],
					},
				}}
				columnHeaderHeight={35}
				rowHeight={40}
				disableAutosize
				// disableRowSelectionOnClick
				hideFooter
			/>
		</Box>
	);
};

export default ResultTable;
